// extracted by mini-css-extract-plugin
export default {"active-icon":"LeftPanel_active-icon__2CJDT","spinning-ai":"LeftPanel_spinning-ai__aVJDY","spin":"LeftPanel_spin__ZQxeI"};